// client/src/constants/categoryIcons.js
// A category's icon is stored server-side as a plain string key (icon_key),
// never a component reference. This is the fixed lookup a category editor
// picks from, and what renders it back client-side.
import KitchenOutlinedIcon from '@mui/icons-material/KitchenOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import TerrainOutlinedIcon from '@mui/icons-material/TerrainOutlined';
import CheckroomOutlinedIcon from '@mui/icons-material/CheckroomOutlined';
import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import YardOutlinedIcon from '@mui/icons-material/YardOutlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import ChairOutlinedIcon from '@mui/icons-material/ChairOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import SportsSoccerOutlinedIcon from '@mui/icons-material/SportsSoccerOutlined';
import ToysOutlinedIcon from '@mui/icons-material/ToysOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ScubaDivingOutlinedIcon from '@mui/icons-material/ScubaDivingOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined';
import AirOutlinedIcon from '@mui/icons-material/AirOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import TrainOutlinedIcon from '@mui/icons-material/TrainOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';

export const ICON_KEY_MAP = {
  planes: FlightOutlinedIcon,
  helicopters: AirOutlinedIcon,
  drones: VideocamOutlinedIcon,
  boats: SailingOutlinedIcon,
  radios: SettingsRemoteOutlinedIcon,
  motors: SpeedOutlinedIcon,
  batteries: BatteryChargingFullOutlinedIcon,
  parts: BuildOutlinedIcon,
  tools: HandymanOutlinedIcon,
  kits: ExtensionOutlinedIcon,
  trains: TrainOutlinedIcon,
  preowned: AutorenewOutlinedIcon,
  collectibles: EmojiEventsOutlinedIcon,
  gifts: CardGiftcardOutlinedIcon,
  kitchen: KitchenOutlinedIcon,
  palette: PaletteOutlinedIcon,
  automotive: DirectionsCarFilledOutlinedIcon,
  baby: ChildCareOutlinedIcon,
  spa: SpaOutlinedIcon,
  books: MenuBookOutlinedIcon,
  camping: TerrainOutlinedIcon,
  clothing: CheckroomOutlinedIcon,
  electronics: DevicesOtherOutlinedIcon,
  gaming: SportsEsportsOutlinedIcon,
  garden: YardOutlinedIcon,
  groceries: LocalGroceryStoreOutlinedIcon,
  health: HealthAndSafetyOutlinedIcon,
  home_kitchen: ChairOutlinedIcon,
  office: EditNoteOutlinedIcon,
  pets: PetsOutlinedIcon,
  sports: SportsSoccerOutlinedIcon,
  toys: ToysOutlinedIcon,
  diving: ScubaDivingOutlinedIcon,
  machinery: PrecisionManufacturingOutlinedIcon,
  other: CategoryOutlinedIcon,
};

export const getCategoryIcon = (iconKey) => ICON_KEY_MAP[iconKey] || CategoryOutlinedIcon;
